class PreconditionFailed extends Error {
  constructor(message = 'Precondition Failed. The request could not be completed due to one or more preconditions in request headers were not met.') {
    super(message)
    this.name = this.constructor.name
    this.status = 412
    Error.captureStackTrace(this, this.constructor)
  }
}

module.exports = PreconditionFailed
